import { render, staticRenderFns } from "./TeamDetailDialog.vue?vue&type=template&id=3bd7ac9a&scoped=true"
import script from "./TeamDetailDialog.vue?vue&type=script&lang=js"
export * from "./TeamDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamDetailDialog.vue?vue&type=style&index=0&id=3bd7ac9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@7.0.0-bridge.0_@babel+core@7.29._1a562a7ff44e47125e24b47fdbb3ae4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd7ac9a",
  null
  
)

export default component.exports